import { Model, belongsTo } from 'miragejs';

export default Model.extend({
  newsletterConfig: belongsTo('newsletter-config', {
    inverse: 'newsletterForms',
  }),
});
